export const ApprovalsActionType = Object.freeze({
    SET_APPROVALS: 'Approvals:: Set approvals data',
    SET_EDIT_APPROVAL: 'Approvals:: Set edit approvals',
    SET_ORDER_BY: 'Approvals:: Set Order by field',
    SET_PAGING_OPT: 'Approvals:: Set Pagination options',
    SET_FILTER: 'Approvals:: Set Filter',
    SET_SEARCH_TEXT: 'Approvals :: Set Search Text',
    SET_PAGE_OFFSET: 'Approvals :: Set Offset of the approvals query',
})

export const APPROVAL_PROP = Object.freeze({
    ID: 'id',
    FNAME: 'firstname',
    LNAME: 'lastname',
    EMAIL: 'email',
    TYPE: 'type',
    DETAILS: 'details',
})

export const APPROVAL_COLUMNS_ENHANCED = Object.freeze([
    {
        id: APPROVAL_PROP.FNAME,
        label: 'Name',
        numeric: false,
        disablePadding: false,
    },
    {
        id: APPROVAL_PROP.EMAIL,
        label: 'Email',
        numeric: false,
        disablePadding: false,
    },
    {
        id: APPROVAL_PROP.DETAILS,
        label: 'Request Type',
        numeric: false,
        disablePadding: false,
    },
])
